// src/frontend_react/src/utils/fileDownloadHelper.js

/**
 * Programmatically triggers a file download in the browser.
 * @param {string|Blob} data - The Blob object of the file or a URL string to the file.
 * @param {string} filename - The desired filename for the downloaded file.
 */
export const triggerBrowserDownload = (data, filename) => {
  const url = (data instanceof Blob) ? window.URL.createObjectURL(data) : data;
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  if (data instanceof Blob) {
    window.URL.revokeObjectURL(url);
  }
};